import { render, staticRenderFns } from "./ResursiveLabel.vue?vue&type=template&id=1d703d7c"
import script from "./ResursiveLabel.vue?vue&type=script&lang=js"
export * from "./ResursiveLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports